import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { BtrEventModel, EventFilterType } from '@app/core/models';
import {
  IBtrEventApiModel,
  IBtrEventListGetRequest,
} from '@app/core/models/api';

@Injectable()
export class BtrEventApiService {
  constructor(private http: HttpClient) {}

  getEvent(
    req: { id: string } | { slug: string },
    withBeacons: boolean = false,
  ): Observable<BtrEventModel> {
    let params = new HttpParams({ fromObject: req });

    if (withBeacons) {
      params = params.append('with_beacons', '1');
    }

    return this.http
      .get<IBtrEventApiModel>(`${environment.API_URL}v5/event.json`, {
        params,
      })
      .pipe(map(res => new BtrEventModel(res)));
  }

  getEvents(data: IBtrEventListGetRequest): Observable<Array<BtrEventModel>> {
    let params = new HttpParams({ fromObject: data as any });
    return this.http
      .get<Array<IBtrEventApiModel>>(`${environment.API_URL}v5.1/events.json`, {
        params,
      })
      .pipe(map(res => res.map(item => new BtrEventModel(item))));
  }

  // getAttendeeInfoList(): Observable<any> {
  //   return this.http.get(`${environment.API_URL}v5/attendeeinfos.json`);
  // }

  getClusterEvents(
    clusterId: number,
    search: string = '',
    filters?: EventFilterType,
  ): Observable<Array<BtrEventModel>> {
    if (!clusterId) {
      return of([]);
    }
    const params: IBtrEventListGetRequest = {
      cluster: clusterId,
      sort: 'start',
      sort_order: 'ASC',
      output_fields: ['beacons', 'tickets'].join(','),
    };
    params.filters = 'actual,regular';
    if (filters?.length > 0 && filters !== EventFilterType.NONE) {
      // params.filters = filters;
      // add filters to params
      params.filters += `,${filters}`;
    }
    if (search?.length > 2) {
      return this.getEvents({
        ...params,
        search,
      });
    }
    return this.getEvents(params);
  }
}
